import { httpClient } from '@/modules/common/services/http/http-client';
import {
  IWithdrawOptionsResponse,
  ICreateWithdrawResponse,
  IScheduleWithdrawalResponse
} from './types';

const httpPlatform = httpClient.withOptions({
  baseURL: `${process.env.VUE_APP_BFF_URL}`
});

export function getWithdrawOptions(): Promise<IWithdrawOptionsResponse> {
  return httpPlatform.get('/transactions/v1/redemptions/withdraw-options');
}

export function newCreateWithdrawal(
  bankAccountId: string,
  withdrawAmount: number
): Promise<ICreateWithdrawResponse> {
  return httpPlatform.post('/transactions/v1/redemptions/create-withdrawal', {
    bankAccountId,
    withdrawAmount
  });
}

export function scheduleWithdrawal(
  bankAccountId: string,
  withdrawAmount: number
): Promise<IScheduleWithdrawalResponse> {
  return httpPlatform.post('/transactions/v1/redemptions/schedule-withdrawal', {
    bankAccountId,
    withdrawAmount
  });
}

export function deleteScheduledTransaction(
  transactionId: string
): Promise<void> {
  return httpPlatform.delete(
    `/transactions/v1/statement/scheduled/${transactionId}`
  );
}
